import React from 'react'
import { 
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    CellFooter, Switch, Toast, Dialog, CellHeader, Label, Input, Toptips
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import { isMoney } from '../../utils'
import Header from '../../components/liveroomLecturer/Header'
import {WKVisible} from '../../components/wk'
import '../../css/page/ChannelEditPage.css'


class ChannelEditTitlePage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isPending: false,
            isNeedMoney: false,
            money: 0,
            isResell: false,
            resellPercent: 0,
            alertDialog: {
                isShow: false,
                text: '',
            },
            longAlertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/channel/${this.props.params.id}/edit_info`)
            .then(res => {
                const channel = res.data.data.channel
                this.setState({ 
                    isNeedMoney: channel.need_money,
                    money: channel.money / 100,
                    isResell: channel.resell_enabled,
                    resellPercent: channel.resell_percent,
                    isPending: false,
                })
            })
    }
    onClickAlertOk () {
        browserHistory.go(-1)
    }
    bindValue (e, field) {
        const value = field === 'resellPercent' && e.target.value > 30 ? 30 : e.target.value
        this.setState({ [field]: value })
    }
    verify (money, resellPercent) {
        if (this.state.isNeedMoney) {
            if (!isMoney(money)) {
                return {
                    status: false,
                    msg: '请输入正确的价格',
                }
            }
            if (money < 0.01 || money > 100000) {
                return {
                    status: false,
                    msg: '专栏售价应在0.01 - 100000之间',
                }
            }
        }
        if (this.state.isResell && this.state.isNeedMoney) {
            if (!/^\d+$/.test(resellPercent) || (resellPercent < 0 || resellPercent > 30)) {
                return {
                    status: false,
                    msg: '比例为0到30的整数',
                }
            }
            if (money * resellPercent / 100 < 0.01) {
                return {
                    status: false,
                    msg: '价格*分成比例必须大于或等于0.01',
                }
            }
        }
        return { status: true }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onSubmit () {
        const { resellPercent, isResell, isNeedMoney, money } = this.state
        const verifyRes = this.verify(money, resellPercent)
        if (!verifyRes.status) {
            this.showTip(verifyRes.msg)
            return
        }
        this.setState({ isPending: true })
        let submitData = {}
        if (isNeedMoney) {
            submitData = {
                need_money: isNeedMoney,
                money: (money ? money * 100 : 1).toFixed(0),
            }
            if (isResell) {
                submitData = {
                    resell_enabled: isResell,
                    resell_percent: resellPercent,
                    ...submitData,
                }
            } else {
                submitData = {
                    resell_enabled: isResell,
                    ...submitData,
                }
            }
        } else {
            submitData = {
                need_money: isNeedMoney,
            }
        }
        axios.post(`/api/channel/${this.props.params.id}/edit`, qs.stringify(submitData))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    // 提示消息过长，用dialog代替
                    if (res.data.msg.length > 30) {
                        this.setState({
                            longAlertDialog: { isShow: true, text: res.data.msg }
                        })
                        return
                    } else {
                        return this.showTip(res.data.msg)
                    }
                }
                this.setState({
                    alertDialog: { isShow: true, text: '修改成功' }
                })
            })
    }
    onClickLongAlertOk () {
        this.setState({ longAlertDialog: { isShow: false } })
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-edit-page">
                    <div className="pay-page">
                        <Header title='付费选项' />
                        <Form className='margin-bottom'>
                            <FormCell switch>
                                <CellBody>设置价格</CellBody>
                                <CellFooter>
                                    <Switch checked={this.state.isNeedMoney} onChange={e => this.setState({ isNeedMoney: e.target.checked })} />
                                </CellFooter>
                            </FormCell>
                            <WKVisible create={this.state.isNeedMoney} tag={null}>
                                <FormCell>
                                    <CellHeader>
                                        <Label>价格（元）</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            type="number" 
                                            placeholder="请输入价格（元）" 
                                            value={this.state.money} 
                                            onChange={e => this.bindValue(e, 'money')} 
                                            disabled={!this.state.isNeedMoney}
                                        />
                                    </CellBody>
                                </FormCell>
                            </WKVisible>
                        </Form>
                        <WKVisible show={this.state.isNeedMoney}>
                            <Form>
                                <FormCell switch>
                                    <CellBody>设置邀请奖励</CellBody>
                                    <CellFooter>
                                        <Switch checked={this.state.isResell} onChange={e => this.setState({ isResell: e.target.checked })} />
                                    </CellFooter>
                                </FormCell>
                                <WKVisible create={this.state.isResell} tag={null}>
                                    <FormCell>
                                        <CellHeader>
                                            <Label>分成比例（%）</Label>
                                        </CellHeader>
                                        <CellBody>
                                            <Input
                                                type="number" 
                                                pattern='[0-9]*'
                                                placeholder="输入1～30的整数作为邀请奖励分成" 
                                                value={this.state.resellPercent} 
                                                onChange={e => this.bindValue(e, 'resellPercent')} 
                                                disabled={!this.state.isResell}
                                            />
                                        </CellBody>
                                    </FormCell>
                                </WKVisible>
                            </Form>
                            <p className="intro">邀请奖励可以刺激用户分享给好友</p>
                        </WKVisible>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                {/* 过长的提示用dialog */}
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickLongAlertOk() }
                ]} show={this.state.longAlertDialog.isShow}>
                    {this.state.longAlertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditTitlePage


// WEBPACK FOOTER //
// ./src/pages/ChannelEdit/ChannelEditPayPage.js